// Dépôt interne (Stock Conthey, entrepôt) — pas une machine.
export const isStockDepot = (d) =>
  !!d && (d.type === "WAREHOUSE" || d.type === "CENTRAL" || d.code === "Stock" || /^Stock\b/i.test(d.name || ""));
